import { Form, Row, Col, Input, Select, DatePicker } from 'antd';
import { useEffect } from 'react';
function EditClientDeclensions({ settings, editingKey }) {
  useEffect(() => {}, [editingKey]);

  return (
    <Row gutter={6}>
      <Form.Item name="classisn" hidden noStyle>
        <Input />
      </Form.Item>
      <Form.Item name="subjisn" hidden noStyle>
        <Input />
      </Form.Item>
      <Col span={8}>
        <Form.Item label="Падеж" name="class_name">
          <Input disabled />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Полное ФИО" name="fullname">
          <Input placeholder="Полное ФИО" />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="Фамилия, иниациалы" name="shortname">
          <Input placeholder="Фамилия, иниациалы" />
        </Form.Item>
      </Col>
    </Row>
  );
}
export default EditClientDeclensions;
